import Compressor from 'compressorjs';
export var compressorFile = function compressorFile(file, quality) {
  return new Promise(function (resolve, reject) {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality: quality,
      success: resolve,
      error: reject
    });
  }).then(function (result) {
    return result;
  }).catch(function (err) {
    throw new Error(err.message);
  });
};
export var FileSize = {
  '300Kb': 300000,
  '3Mb': 3000000,
  '4Mb': 4000000,
  '5Mb': 5000000,
  '8Mb': 8000000,
  '9Mb': 9000000
};